import { useDispatch } from 'react-redux'

import Grid from '@mui/material/Grid'

import { useGET_groupSelectQuery } from 'redux/api/groupsApi'
import { useGET_courseSelectQuery } from 'redux/api/coursesApi'

import { AppDispatch } from 'redux/store'
import { setGroup, setCourse, setStatus, trackActiveFilters } from 'redux/ui/groupCoursesUI'

import SelectField from 'components/atoms/fields/SelectField'

import formModel from 'utils/tableFilterModels/groupCoursesTableFilterModel'
import { enrollmentStatusSelectData} from 'utils/helpers'

const ExtraFiltersGroupCourses = () => {
  const dispatch = useDispatch<AppDispatch>()

  const { group, course, status } = formModel()

  return (
    <>
      <Grid item xs={12} md={4}>
      <SelectField
          fieldProps={{ ...group }}
          apiCall={useGET_groupSelectQuery}
          onChange={(value: { id: any }) => {
            dispatch(setGroup(value?.id ?? ''))
            dispatch(trackActiveFilters())
          }}
        />
      </Grid>
      <Grid item xs={12} md={4}>
      <SelectField
          fieldProps={{ ...course }}
          apiCall={useGET_courseSelectQuery}
          onChange={(value: { id: any }) => {
            dispatch(setCourse(value?.id ?? ''))
            dispatch(trackActiveFilters())
          }}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <SelectField
          renderChildren={false}
          fieldProps={{ ...status }}
          apiCall={enrollmentStatusSelectData}
          onChange={(value: { id: any }) => {
            dispatch(setStatus(value?.id ?? ''))
            dispatch(trackActiveFilters())
          }}
        />
      </Grid>
    </>
  )
}
export default ExtraFiltersGroupCourses